<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：回复评价
    -->
    <el-dialog
    title="回复评价"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" label-width="100px">
      <div class="common-form">评价</div>
      <el-form-item label="评价内容" prop="content"><el-input v-model="form.content" 
        placeholder="请输入评价内容" type="textarea" class="max-w460"></el-input></el-form-item>
 
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</el-dialog>
  
</template>

<script>
import PorductApi from '@/api/product.js';
export default {
  data() {
    return {
            /*富文本配置*/
            ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {

        content: ''
      },
      isproduct:false,
      tableData: [],
      product_arr: [],
      loading: false,
      dialogVisible:false,
      isProductUpload:false,
      tableData_index:0,
    };
  },
  created() {
    this.dialogVisible = this.open_huifu;
  },
  props: ["open_huifu","comment_id"],
  methods: {
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible(1)
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      form.comment_id=self.comment_id;
      PorductApi.huifuComment(form,
        true
      ).then(data => {
          self.loading = false;
          this.dialogFormVisible(1)
      }).catch(error => {});

    },


  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/comment/huifu.vue